import type React from 'react';

import { ActivityGraph } from './ActivityGraph';

export interface ActionItemsFocusChartLiveProps {
  seedTodayOnEmpty?: boolean;
}

export const ActionItemsFocusChartLive: React.FC<
  ActionItemsFocusChartLiveProps
> = () => {
  return <ActivityGraph />;
};
